////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'

/////////STYLED/////////
const ModalBodyWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 35px;
`
/////////STYLED/////////

/**
 *
 * @param {object} children
 * @returns {*}
 * @constructor
 */
const ModalBody = ({ children }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return <ModalBodyWrapper>{children}</ModalBodyWrapper>
}

ModalBody.propTypes = {}

export default ModalBody
